import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraSelect, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraInlineBanner } from '@mono/ui-components/lieutenants';
import { GroupSection } from './PricingTableParts';
export function TierComposition({ tier, rateCard, columns, periods, onChange }) {
    const current = tier.group.lines.reduce((sum, line)=>sum + (line.fteCount ?? 0), 0);
    const { min, max } = tier.fteConstraints;
    const warning = min !== undefined && current < min || max !== undefined && current > max;
    const available = rateCard?.categories.filter((c)=>!c.removedFromSectionB && !tier.group.lines.some((l)=>l.laborCategoryId === c.laborCategoryId)) ?? [];
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsxs(SpecraText, {
                children: [
                    tier.tierLabel,
                    " · ",
                    current,
                    " FTEs · required ",
                    min ?? '—',
                    "–",
                    max ?? '—'
                ]
            }),
            warning && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "warning",
                children: "Tier composition is outside its FTE constraints."
            }),
            /*#__PURE__*/ _jsx(GroupSection, {
                group: tier.group,
                columns: columns,
                periods: periods,
                removable: true,
                onChange: (group)=>onChange({
                        ...tier,
                        group
                    }),
                onRemove: (id)=>onChange({
                        ...tier,
                        group: {
                            ...tier.group,
                            lines: tier.group.lines.filter((l)=>l.id !== id)
                        }
                    })
            }),
            /*#__PURE__*/ _jsxs(SpecraSelect, {
                "aria-label": `Add role to ${tier.tierLabel}`,
                value: "",
                disabled: !available.length,
                onChange: (event)=>{
                    const cat = available.find((c)=>c.id === event.target.value);
                    if (!cat) return;
                    const param = (name, source, paramType)=>({
                            name,
                            label: name,
                            paramType,
                            source,
                            value: null,
                            perPeriod: false
                        });
                    onChange({
                        ...tier,
                        group: {
                            ...tier.group,
                            lines: [
                                ...tier.group.lines,
                                {
                                    id: crypto.randomUUID(),
                                    laborCategoryId: cat.laborCategoryId,
                                    lcatLogicalKey: cat.lcatLogicalKey,
                                    label: cat.title,
                                    parameters: {
                                        hours: param('hours', 'contractor', 'quantity'),
                                        rate: param('rate', 'computed', 'rate'),
                                        total: {
                                            ...param('total', 'computed', 'currency'),
                                            formula: {
                                                type: 'multiply',
                                                operands: [
                                                    'hours',
                                                    'rate'
                                                ]
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ _jsx("option", {
                        value: "",
                        children: "Add role…"
                    }),
                    available.map((cat)=>/*#__PURE__*/ _jsx("option", {
                            value: cat.id,
                            children: cat.title
                        }, cat.id))
                ]
            })
        ]
    });
}
